<template>
  <div class="container">
    <div class="card">
      <h1>NetworkChuck Academy CCNA Beta Tester Signup Form</h1>
      <p class="required-note">* Indicates required question</p>

      <p>Thank you for your interest in testing the new NetworkChuck Academy experience!</p>

      <form @submit.prevent="submitForm">
        <label>
          Your Name *
          <input type="text" v-model="form.name" required />
        </label>

        <label>
          Email Address *
          <input type="email" v-model="form.email" required />
        </label>

        <label>
          Where are you from?
          <input type="text" v-model="form.role" />
        </label>

        <label>
          How old are you? *
          <select v-model="form.age" required>
            <option disabled value="">Select age range</option>
            <option>18-25</option>
            <option>26-30</option>
            <option>31-40</option>
            <option>41-50</option>
            <option>51-60</option>
            <option>61-65</option>
            <option>Over 65</option>
          </select>
        </label>

        <label>
          What's your experience level with CCNA material? *
          <select v-model="form.experience" required>
            <option disabled value="">Select your level</option>
            <option>Newbie: Just starting out, little to no CCNA exposure</option>
            <option>Beginner: Know the basics, maybe watched a few videos or read an intro book</option>
            <option>Intermediate: Comfortable with core concepts and basic configs; labbing regularly</option>
            <option>Advanced: Confident with most CCNA topics; can troubleshoot and explain concepts clearly</option>
            <option>Expert: Practically teaching this stuff; deep hands-on experience and strong real-world understanding</option>
          </select>
        </label>

        <label>
          How did you hear about this beta program?
          <input type="text" v-model="form.referral" />
        </label>

        <p class="agreement">
          By hitting submit, you agree to receive email communication at the email address you provide. You understand that not everyone will be selected.
        </p>

        <div class="form-buttons">
          <button type="submit" :disabled="submitting" class="button">
            {{ submitting ? 'Submitting...' : 'Submit' }}
          </button>
          <router-link to="/" class="text-link">← Back to Home</router-link>
        </div>
      </form>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <h2>Thank You!</h2>
        <p>We appreciate your willingness to participate in the CCNA Beta Tester Program.</p>
        <button @click="redirect" class="button">Go to Academy</button>
      </div>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export default {
  name: "SignupForm",
  data() {
    return {
      form: {
        name: "",
        email: "",
        role: "",
        age: "",
        experience: "",
        referral: "",
      },
      showModal: false,
      submitting: false,
    };
  },
  methods: {
    async submitForm() {
      this.submitting = true;
      try {
        console.log('🔥 Calling submitBetaSignup with data:', this.form);

        const submitBetaSignup = httpsCallable(functions, 'submitBetaSignup');
        const result = await submitBetaSignup({ ...this.form });
        console.log("✅ Submitted with ID:", result.data.id);
        this.showModal = true;
      } catch (error) {
        console.error("❌ Cloud Function error:", error);
        alert(`Something went wrong: ${error.message}`);
      } finally {
        this.submitting = false;
      }
    },
    redirect() {
      window.location.href = "https://academy.networkchuck.com";
    },
  },
};
</script>

<style>
body {
  font-family: 'Inter', Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #171723;
  background-image: url('https://firebasestorage.googleapis.com/v0/b/networkchuck-academy-prod.firebasestorage.app/o/SKY%20BG2.png?alt=media');
  background-repeat: no-repeat;
  background-size: cover;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.card {
  background-color: #171723;
  border-radius: 12px;
  padding: 30px;
  max-width: 900px;
  width: 100%;
  color: #fff;
  line-height: 1.8;
}
h1 {
  color: #CA9F43;
  margin-top: 0;
  font-weight: bold;
  font-size: 28px;
  text-align: left;
}
.required-note {
  color: red;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 16px;
}
label {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  font-weight: bold;
}
input, select {
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-top: 4px;
  background-color: #2a2a35;
  color: #fff;
}
button, .button {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  color: #000 !important;
  background-color: #CA9F43;
  border-radius: 48px;
  padding: 12px 35px;
  text-decoration: none !important;
  margin-top: 20px;
  width: fit-content;
}
button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.agreement {
  font-size: 14px;
  color: #ccc;
  margin-top: 12px;
}
a {
  color: #CA9F43;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background-color: #171723;
  padding: 30px;
  border-radius: 12px;
  color: #fff;
  text-align: center;
  max-width: 500px;
  width: 90%;
}
.modal-content h2 {
  color: #CA9F43;
  margin-bottom: 16px;
}
.modal-content p {
  color: #ccc;
  margin-bottom: 20px;
}
.form-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px; /* space between submit and back link */
  margin-top: 20px;
}
.text-link {
  color: #CA9F43;
  font-weight: bold;
  font-size: 16px;
  text-decoration: none;
}
.text-link:hover {
  text-decoration: underline;
}
</style>

